module.exports = __webpack_public_path__ + "img/Camden_Hand.50dc29b1.png";